function changeQuantity(inputBlock){
    let input = $(inputBlock).find('input[type="number"]'),
        minus = $(inputBlock).find('.minus'),
        plus = $(inputBlock).find('.plus'),
        inputValue;
    
    minus.on(click_event, () => input.val() > 1 ? input.val(+input.val()-1) : input.val(1));
    plus.on(click_event, () => input.val(+input.val()+1));

    input.on('focus', ()=>{
        inputValue = input.val();
        input.val(null)
    })
    input.on('blur', ()=>{
        if(inputValue &&  input.val() == ''){
            input.val(inputValue)
        }
        if(input.val() < 1){
            input.val(1)
        }
    })
}


$(function(){
    $('.price-block').each((i, el) => {        
        changeQuantity($(el).find('.quantity'))
    });

    if($('.delButton').length != 0){
        $('.delButton').on(click_event, function(){
            $(this).closest('.order-item').remove();

            if($('.order-item').length <= 0){
                $('.empty-block').removeClass('hide')
                $('.form-footer').addClass('hide')
            }
        })
    }

    if($('#myInfoForm').length != 0){
        let activityInput = $('.activity');

        activityInput.on('focus', function(){
            $(this).siblings('.hidden-list').addClass('visible');
        })

        $('.hidden-list__item').on('click', function(e){
            e.preventDefault();
            activityInput.val($(this).text());
            $(this).parent().removeClass('visible');
        })

        activityInput.on('input', function(e){
            if($(this).val().length >= 3 && $('.hidden-list').hasClass('visible')){
                $('.hidden-list').removeClass('visible')
            }
        })
    }
})